import { render, staticRenderFns } from "./VendingCategories.vue?vue&type=template&id=a62cec92"
import script from "./VendingCategories.vue?vue&type=script&lang=js"
export * from "./VendingCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports